import React, { useEffect, useState } from 'react'
import banner from "../../../images/background/parallax-2.jpg"
import axios from 'axios';
import { ToastContainer,toast } from "react-toastify";
import { Link } from 'react-router-dom'
import Header from "../../../components/User/Header/Header"
import Footer from '../../../components/User/Footer/Footer'
import HomeBanner from "../../../images/background/homeBanner.jpg"

function ContactUs() {
const[formData,setFormData]=useState({
    firstName:"",
    lastName:"",
    email:"",
    message:""
  })
  const baseAPI = process.env.REACT_APP_API_URL;
    useEffect(()=>{
    window.scrollTo(0,0)
      },[])

      const handleChange=(e)=>{
        const{name,value}=e.target
    setFormData({...formData,[name]:value})
      }
    
      const handleSubmit = async (e) => {
        e.preventDefault();
       if(formData.email===''){
        return  toast.error('Email Address is missing', {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light"
              });
       }
          try {
            const response = await axios.post(
              `${baseAPI}/CMB/AddAppointmentData`,
              formData
            );
            toast.success('Form Submitted Successfully', {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: false,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
              transition: 'Bounce',
              });
              setFormData({ firstName:"",
                lastName:"",
                email:"",
                message:""})
          } catch (error) {
            console.error("Error posting data:", error);
          }
      };

  return (
    <div>
        <Header/>
        <section
          class="call-to-action-one sp-four"
          style={{ backgroundImage: `url(${HomeBanner})` }}
        >
          <div class="container">
            <div class="sec-title-one white text-center">
              {/* <h5>Keep Runing</h5> */}
              <h2>Contact Us</h2>
            </div>
            {/* <div class="text mt-20 mb-50">
              Excepteur sint occaecat cupidatat non proident, sunt in culpa qui
              officia deserunt mollit anim id est <br /> laborum.sed ut
              perspiciatis unde.
            </div>
            <div class="link-btn">
              <a href="#" class="theme-btn btn-style-two">
                Get Appointment
              </a>
            </div> */}
          </div>
        </section>
    <section class="contact-info sp-two grey-bg">
        <div class="container">
            <div class="sec-title-one centered mb-60">
                {/* <h5>Quick Contact</h5> */}
                <h2><span>Let’s</span> Connect </h2>
                <div class="text">
                We love hearing from you. Need help with a shipment or have a question?<br/> Get in touch with us via phone, mail, and more. 
                                </div>
            </div>
            <div class="row">

                <div class="col-xl-4 col-sm-6 col-sm-12 mb-50">
                    <div class="contact-item-one">
                        <i class="flaticon-location"></i>
                        <h6>Our Location</h6>
                        <p>B-85, 3rd Floor, Defence Colony, New Delhi 110024</p>
                    </div>
                </div>

                <div class="col-xl-4 col-sm-6 col-sm-12 mb-50">
                    <div class="contact-item-one">
                        <i class="flaticon-technology"></i>
                        <h6>Call Us Now</h6>
                        <p>+91-9999136186
                        {/* (+48) 564-334-21-25 */}
                        </p>
                          <br/>
                    </div>
                </div>

                <div class="col-xl-4 col-sm-6 col-sm-12 mb-50">
                    <div class="contact-item-one">
                        <i class="flaticon-message"></i>
                        <h6>Write Us Now</h6>
                        <p><a href="">support@carrymybaggage.com</a> 
                        {/* <a href="">info@example.com</a> */}
                        </p>
                        <br/>
                    </div>
                </div>

            </div>
        </div>
    </section>
   
    <section class="contact-us sp-one">
        <div class="container">
            <div class="row">
                <div class="col-xl-6 col-md-12 col-sm-12">
                    <div class="contact-area">
                        <div class="sec-title-one mb-50 text-center">
                            {/* <h5>Write Message</h5> */}
                            <h2><span>Get In</span> Touch</h2>
                        </div>
                        <div class="default-form-area">
                            <form id="contact-form" name="contact_form" class="contact-form contact-us">       
                                <div class="form-group">
                                    <input type="text" name="firstName" onChange={handleChange} class="form-control" value={formData.firstName} placeholder="Your Name" required=""/>
                                </div>      
                                <div class="form-group">
                                    <input type="email" name="email" onChange={handleChange} class="form-control required email" value={formData.email} placeholder="Your Email" required=""/>
                                </div>
                                <div class="form-group">
                                    <textarea name="message" onChange={handleChange} value={formData.message} class="form-control textarea required" placeholder="Your Message"></textarea>
                                </div>
                                <div class="form-group">
                                    <input id="form_botcheck" name="form_botcheck" class="form-control" type="hidden" value=""/>
                                    <button onClick={handleSubmit} class="theme-btn btn-style-two" type="submit" data-loading-text="Please wait...">Submit Now</button>
                                </div>
                            </form>
                        </div>
                        <ToastContainer
                        position="top-right"
                        autoClose={5000}
                        hideProgressBar={false}
                        newestOnTop={false}
                        closeOnClick={false}
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                        theme="light"
                        />
                    </div>
                </div>
                <div class="col-xl-6 col-md-12 col-sm-12">
                    <div class="google-map-area mobile-view-hide">
                        <div 
                            class="google-map" 
                            id="contact-google-map" 
                            data-map-lat="40.700843" 
                            data-map-lng="-74.004012" 
                            data-icon-path="images/icons/map-marker.png"
                            data-map-title="Chester"
                            data-map-zoom="11" >
                        {/* <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3506.351066071898!2d77.07833181047941!3d28.499083575636654!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390d1d1790699001%3A0x49aa255570582421!2sDBB%20WORLDWIDE%20PVT%20LTD!5e0!3m2!1sen!2sin!4v1736501806574!5m2!1sen!2sin" width="100%" height="702" style={{border:'0'}} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe> */}
                       <iframe  src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3823.4215339427387!2d77.22344107583592!3d28.56847897569974!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMjjCsDM0JzA2LjUiTiA3N8KwMTMnMzMuNyJF!5e1!3m2!1sen!2sin!4v1754474029208!5m2!1sen!2sin" width="100%" height="702" style={{border:'0'}}  allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>

                        </div>
                    </div>
                    <div class="google-map-area mobile-view-show">
                        <div 
                            class="google-map" 
                            id="contact-google-map" 
                            data-map-lat="40.700843" 
                            data-map-lng="-74.004012" 
                            data-icon-path="images/icons/map-marker.png"
                            data-map-title="Chester"
                            data-map-zoom="11" >
                        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3506.351066071898!2d77.07833181047941!3d28.499083575636654!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390d1d1790699001%3A0x49aa255570582421!2sDBB%20WORLDWIDE%20PVT%20LTD!5e0!3m2!1sen!2sin!4v1736501806574!5m2!1sen!2sin" width="100%" height="394" style={{border:'0'}} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <Footer/>
    </div>
  )
}

export default ContactUs